import EmptyState from './util/EmptyState';
import React, { useEffect, useState, useCallback, useRef, useMemo } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { Dayjs } from 'dayjs';
import TimePicker from './util/TimePicker';
import { getCompanyTimeStep } from './util/timeStep';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import moment from 'moment';
import 'moment-timezone';
import { transformToHierarchy } from './util/tree';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useSnackbar } from 'notistack';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import dayjs from 'dayjs';
import isoWeekPlugin from 'dayjs/plugin/isoWeek';
import { useLocation, useNavigate } from 'react-router-dom';
import ApproveModal from './modal/ApproveModal';
import { t } from 'i18next';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
// import Template from './Template'; // вкладка Templates удалена
import ToilCalendar from './toilsComponents/ToilCalendar';
import TemplatesPanel, { PendingEntry } from './timesheetsComp/TemplatesPanel';
import SidePanel from './util/SidePanel';
import EditReports from './modal/EditReports';
import Reports from './Reports';
import ReportsNew from './reportsComponents/ReportsNew';
import Approvals from './Approvals';
import SelectTask from './timesheetsComp/SelectTask';
import Select from 'react-select';
import TreeViewComponent from './util/TreeViewComponent';
import { getMondayOf, buildWeekFromMonday } from './timesheetsComp/WeekCalendarPicker';
import PageToolbar from './util/PageToolbar';
import SearchFilter, { ActiveFilter } from './util/SearchFilter';
import { ColDef } from './util/DataTable';
import CategoryTaskPicker from './timesheetsComp/CategoryTaskPicker';
import TimesheetsSettings from './modal/TimesheetsSettings';
import SettingsPanelBody from './util/SettingsPanelBody';

dayjs.extend(isoWeekPlugin);

interface Report {
  date: string;
  startTime: string;
  endTime: string;
  description: string;
  status: string;
}

interface TimeSheetsProps {
  access: any;
  is24HourFormat: boolean;
  taskOrTasks: any;
  staticDateCompany: any;
  refreshUserHeder: any;
  baseUrl?: string;
}

interface Temp {
  temp_group_number: string;
  temp_name: string;
}


/* ─────────────────────────────────────────
   Status badge
───────────────────────────────────────── */
const StatusBadge: React.FC<{ status: string }> = ({ status }) => (
  <span className={`sbadge ${status}`}>{status}</span>
);

/* ─────────────────────────────────────────
   Main component
───────────────────────────────────────── */
// react-select для селектора сотрудника («Self») — компактный вид как в тулбаре Reports
const daySelectStyles: any = {
  control: (b: any, s: any) => ({
    ...b, minHeight: 32, height: 32, minWidth: 136,
    background: 'var(--bg-input)',
    border: s.isFocused ? '1px solid rgba(37,99,235,.4)' : '1px solid rgba(0,0,0,.08)',
    borderRadius: 8, boxShadow: s.isFocused ? '0 0 0 2px rgba(37,99,235,.1)' : 'none',
    fontSize: 12, fontWeight: 600, cursor: 'pointer',
    '&:hover': { borderColor: 'rgba(37,99,235,.3)' },
  }),
  valueContainer: (b: any) => ({ ...b, padding: '0 8px', height: 32 }),
  singleValue: (b: any) => ({ ...b, color: 'var(--text-color)', margin: 0 }),
  input: (b: any) => ({ ...b, color: 'var(--text-color)', margin: 0, padding: 0 }),
  indicatorsContainer: (b: any) => ({ ...b, height: 32 }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (b: any) => ({ ...b, padding: '0 6px', color: 'var(--text-color-calendar-week)' }),
  menu: (b: any) => ({ ...b, background: 'var(--bg-form)', border: '1px solid rgba(0,0,0,.08)', borderRadius: 10, boxShadow: '0 8px 24px rgba(0,0,0,.12)', overflow: 'hidden', minWidth: 150 }),
  menuPortal: (b: any) => ({ ...b, zIndex: 'var(--z-portal)' as any }),
  option: (b: any, s: any) => ({
    ...b, fontSize: 12, fontWeight: s.isSelected ? 700 : 500, cursor: 'pointer',
    background: s.isSelected ? 'rgba(37,99,235,.1)' : s.isFocused ? 'var(--btn-user-form)' : 'transparent',
    color: s.isSelected ? '#2563eb' : 'var(--text-color)',
  }),
};

const selfSelectStyles: any = {
  control: (b: any, s: any) => ({
    ...b, minHeight: 32, height: 'auto', minWidth: 160,
    background: 'var(--bg-input)',
    border: s.isFocused ? '1px solid rgba(37,99,235,.4)' : 'var(--border-input)',
    borderRadius: 8, boxShadow: s.isFocused ? '0 0 0 2px rgba(37,99,235,.1)' : 'none',
    fontSize: 13, fontWeight: 600, cursor: 'pointer',
    '&:hover': { borderColor: 'rgba(37,99,235,.3)' },
  }),
  valueContainer: (b: any) => ({ ...b, padding: '2px 8px' }),
  singleValue: (b: any) => ({ ...b, color: 'var(--text-color)' }),
  input: (b: any) => ({ ...b, color: 'var(--text-color)' }),
  placeholder: (b: any) => ({ ...b, color: 'var(--text-color-calendar-week)' }),
  indicatorsContainer: (b: any) => ({ ...b, height: 32 }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (b: any) => ({ ...b, padding: '0 6px', color: 'var(--text-color-calendar-week)' }),
  menu: (b: any) => ({ ...b, background: 'var(--bg-form)', border: '1px solid var(--border-input)', borderRadius: 10, boxShadow: '0 8px 24px rgba(0,0,0,.15)', overflow: 'hidden' }),
  menuPortal: (b: any) => ({ ...b, zIndex: 'var(--z-portal)' as any }),
  option: (b: any, s: any) => ({
    ...b, fontSize: 13, cursor: 'pointer',
    background: s.isSelected ? 'rgba(37,99,235,.1)' : s.isFocused ? 'var(--btn-user-form)' : 'transparent',
    color: s.isSelected ? '#2563eb' : 'var(--text-color)',
  }),
};

const Timesheets: React.FC<TimeSheetsProps> = ({
  access,
  is24HourFormat,
  taskOrTasks,
  staticDateCompany,
  refreshUserHeder,
  baseUrl = '',
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [category, setCategory] = useState<any[]>([]);
  const [userInfo, setUserInfo] = useState('');
  const [reports, setReports] = useState([]);
  const [users, setUsers] = useState([]);
  const [usersSuperId, setUsersSuperId] = useState('none');
  const [startDate, setStartDate] = useState(new Date());
  const [timeFrom, setTimeFrom] = useState(moment().hour(9).minute(0).toDate());
  const [timeTo, setTimeTo]     = useState(moment().hour(17).minute(0).toDate());
  const [categoryName, setCategoryName] = useState<any[]>([]);
  const [allCategory, setAllCategory]   = useState<any[]>([]);
  const auth = useSelector((state: RootState) => state.auth.value);
  const dispatch = useDispatch();
  const [selectedCategoryId, setSelectedCategoryId] = useState<number[]>([]);
  const transformToHierarchyCallback = useCallback(transformToHierarchy, []);
  const [isCategoryListVisible, setCategoryListVisible] = useState(false);
  const [test, setTest] = useState<any>();
  const [week, setWeek]       = useState<Dayjs[]>([]);
  const [dayPick, setDayPik]  = useState<Dayjs | null>(null);
  const [openCheckModal, setCheckOpenModal] = useState(false);
  const [selectedTasks, setSelectedTasks]   = useState<any[]>([]);
  const [page, setPage]             = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [perWeek, setPerWeek]       = useState('');
  const location = useLocation();
  const [toils, setToils]           = useState<any>();
  const [loading, setLoading]       = useState(false);
  const [loadingWeek, setLoadingWeek] = useState(false);
  const [showTemplatesPanel, setShowTemplatesPanel]       = useState(false);
  const [pendingTemplateEntries, setPendingTemplateEntries] = useState<PendingEntry[]>([]);
  const [showAprove, setShowAprove]     = useState(false);
  const [showReturnWeek, setReturnWeek] = useState(false);
  const [buttonAdd, setButtonAdd]       = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [allTemplate, setAllTemplate]         = useState<any[]>([]);
  const [allTemplateSelect, setAllTemplateSelect] = useState<Temp[]>([]);
  // ?tab=approvals (dashboard "Open in Approvals") opens the Approvals tab when allowed
  const [tabValue, setTabValue] = useState(() =>
    new URLSearchParams(location.search).get('tab') === 'approvals' && access?.timesheet_approve_enabled ? 'approvals' : 'timesheets');
  const navigate = useNavigate();
  const [selected, setSelected] = useState<readonly number[]>([]);

  // ── Settings panel ──
  const [settingsOpen, setSettingsOpen] = useState(false);

  // ── New state for new design ──
  const [showInlineForm, setShowInlineForm] = useState(false);
  const [formDescription, setFormDescription] = useState('');
  const [formErrors, setFormErrors] = useState<{ time?: boolean; category?: boolean; task?: boolean }>({});
  const [formTimeFromStr, setFormTimeFromStr] = useState('09:00');
  const [formTimeToStr,   setFormTimeToStr]   = useState('17:00');

  // Snap time string "HH:mm" to nearest 15 minutes
  const snapTo15 = (val: string): string => {
    if (!val) return val;
    const [h, m] = val.split(':').map(Number);
    const snapped = Math.round(m / 15) * 15;
    if (snapped >= 60) return `${String(h + 1).padStart(2, '0')}:00`;
    return `${String(h).padStart(2, '0')}:${String(snapped).padStart(2, '0')}`;
  };
  const [formDayIndex, setFormDayIndex] = useState(0);
  const [isEditing, setIsEditing]       = useState(false);
  const [editRowId, setEditRowId]       = useState<number | null>(null);
  const [userPattern, setUserPattern]   = useState<any>(null);
  const descRef = useRef<HTMLTextAreaElement>(null);

  // Adds 1 hour to "HH:mm", caps at "00:00" (midnight)
  const addOneHour = (time: string): string => {
    const [h, m] = time.split(':').map(Number);
    const total = h * 60 + m + 60;
    if (total >= 1440) return '00:00';
    return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
  };

  // Derived week label
  const weekStart = week.length > 0 ? week[0] : dayjs().startOf('isoWeek' as any);
  const weekEnd   = week.length > 0 ? week[6] : dayjs().startOf('isoWeek' as any).add(6, 'day');
  const weekLabel = `${weekStart.format('D MMM')} – ${weekEnd.format('D MMM YYYY')}`;
  const weekIso   = weekStart.isoWeek();

  const transformedWeek = useMemo(
    () => week.map((date: any) => moment(date.$d).format('DD.MM.YYYY')),
    [week],
  );

  // ── Initialize week on mount (today's ISO week) ──
  useEffect(() => {
    if (week.length === 0) {
      const mon = dayjs().startOf('isoWeek' as any);
      setWeek(Array.from({ length: 7 }, (_, i) => mon.add(i, 'day')));
    }
  }, []); // eslint-disable-line

  // ── Week navigation ──
  const navToWeek = (mon: Dayjs) => {
    setWeek(Array.from({ length: 7 }, (_, i) => mon.add(i, 'day')));
    setDayPik(mon);
    setFormDayIndex(0);
  };
  const prevWeek = () => navToWeek(weekStart.subtract(7, 'day'));
  const nextWeek = () => navToWeek(weekStart.add(7, 'day'));
  const goToday  = () => navToWeek(dayjs().startOf('isoWeek' as any));

  // ── Category handlers (same as original) ──
  const handleClickCategoryBox = (event: React.MouseEvent) => {
    setCategoryListVisible(!isCategoryListVisible);
    event.stopPropagation();
  };
  const handleCategoryListClick = (event: React.MouseEvent) => { event.stopPropagation(); };

  const handleNodeSelect = (nodeId: number) => {
    setSelectedCategoryId([nodeId]);
    if (nodeId === -1) { setCategoryName(['none']); setCategoryListVisible(false); return; }
    const selectedCategory = allCategory?.find(node => node.id === Number(nodeId));
    if (selectedCategory) {
      const hasChildren = allCategory.some(node => node.parentId === Number(nodeId));
      if (hasChildren) return;
      setCategoryName(selectedCategory.name);
      setTest(nodeId);
      setCategoryListVisible(false);
    }
  };

  useEffect(() => {
    const handleDocumentClick = () => setCategoryListVisible(false);
    if (isCategoryListVisible) document.addEventListener('click', handleDocumentClick);
    return () => document.removeEventListener('click', handleDocumentClick);
  }, [isCategoryListVisible]);

  // ── Templates ──
  const refreshTempaleList = async () => {
    try {
      if (usersSuperId === 'none') {
        const { data } = await axios.get('template/user');
        const { data: template } = await axios.get('template/user/group');
        setAllTemplate(data);
        setAllTemplateSelect(template);
      } else {
        const { data } = await axios.post('template/user/sub', { userId: usersSuperId });
        const { data: template } = await axios.post('template/user/group/sub', { userId: usersSuperId });
        setAllTemplate(data);
        setAllTemplateSelect(template);
      }
    } catch { }
  };

  const refreshSelectTemplate = async () => {
    try {
      let templateData;
      if (usersSuperId === 'none') {
        const { data: template } = await axios.get('template/user/group');
        templateData = template;
      } else {
        const { data: template } = await axios.post('template/user/group/sub', { userId: usersSuperId });
        templateData = template;
      }
      setAllTemplateSelect(templateData);
    } catch { }
  };


  // ── Reset form ──
  const resetForm = () => {
    setShowInlineForm(false);
    setIsEditing(false);
    setEditRowId(null);
    setFormDescription('');
    setCategoryName([]);
    setSelectedCategoryId([]);
    setTest(undefined);
    setSelectedTasks([]);
    setFormTimeFromStr('09:00');
    setFormTimeToStr('17:00');
    setFormErrors({});
  };

  // ── Open edit form inline ──
  const handleEditClick = (row: any) => {
    const rowDate = new Date(row.date);
    const dayIdx  = week.findIndex(d => dayjs(d).isSame(rowDate, 'day'));
    setFormDayIndex(dayIdx >= 0 ? dayIdx : 0);
    setStartDate(moment(row.date).set({ hour: 12, minute: 0, second: 0 }).toDate());
    setFormTimeFromStr(moment.utc(row.startTime).format('HH:mm'));
    setFormTimeToStr(moment.utc(row.endTime).format('HH:mm'));
    setSelectedCategoryId([row.categoryid]);
    setCategoryName([row.categoryTree?.split(' > ').pop() || '']);
    setTest(row.categoryid);
    setSelectedTasks((row.tasks || []).map((tk: any) => ({ value: tk.id, label: tk.name || tk.label || '' })));
    setFormDescription(row.description || '');
    setFormErrors({});
    setEditRowId(row.id);
    setIsEditing(true);
    setShowInlineForm(true);
  };

  // ── Add / Update entry ──
  const handleAddClick = async () => {
    const description = formDescription.trim();
    const [fh, fm] = formTimeFromStr.split(':').map(Number);
    const [th, tm] = formTimeToStr.split(':').map(Number);
    const fromMins = fh * 60 + fm;
    const toMins   = th * 60 + tm;
    const isOvernight = toMins < fromMins; // 22:30 → 01:30 — следующий день
    const fromDate = moment(startDate).set({ hours: fh, minutes: fm, seconds: 0 });
    const toDate   = moment(startDate).set({ hours: th, minutes: tm, seconds: 0 });

    const errors: { time?: boolean; category?: boolean; task?: boolean } = {};
    // Ошибка только если from === to (нулевая длительность); overnight всегда валиден
    if (fromMins === toMins) errors.time = true;
    if (selectedCategoryId.length === 0 || !categoryName.length) errors.category = true;
    if (selectedTasks.length === 0) errors.task = true;

    if (Object.keys(errors).length > 0) { setFormErrors(errors); return; }
    setFormErrors({});

    const endDateStr = isOvernight
      ? moment(startDate).add(1, 'day').format('YYYY-MM-DD')
      : moment(startDate).format('YYYY-MM-DD');
    const tasksArr = selectedTasks.map((o: any) => o.value);

    setButtonAdd(true);
    try {
      if (isEditing && editRowId) {
        // ── UPDATE ──
        await axios.put(`time-reports/update-reports/${editRowId}`, {
          date: startDate,
          startTime: moment(startDate).format('YYYY-MM-DD') + ' ' + fromDate.format('HH:mm:ss'),
          endTime: endDateStr + ' ' + formTimeToStr + ':00',
          categoryId: test,
          taskId: tasksArr,
          description,
        });
        enqueueSnackbar('Entry updated', { variant: 'success' });
      } else {
        // ── CREATE ──
        if (!week.some(day => dayjs(day).isSame(startDate, 'day'))) {
          enqueueSnackbar('Selected date is outside the current week', { variant: 'error' }); return;
        }
        const neDate = isOvernight ? toDate.clone().add(1, 'day') : toDate.clone();
        const isTimeConflict = rows.some((report: any) => {
          const es = moment(report.startTime).startOf('minute');
          const ee = moment(report.endTime).startOf('minute');
          const ns = fromDate.clone().startOf('minute');
          const ne = neDate.startOf('minute');
          return moment(startDate).isSame(report.date, 'day') && ns.isBefore(ee) && ne.isAfter(es);
        });
        if (isTimeConflict) {
          enqueueSnackbar('Time conflict: that slot is already occupied', { variant: 'error' }); return;
        }
        await axios.post('/time-reports', {
          date: startDate,
          startTime: moment(startDate).format('YYYY-MM-DD') + ' ' + fromDate.format('HH:mm:ss'),
          endTime: endDateStr + ' ' + formTimeToStr + ':00',
          categoryId: test,
          description,
          tasksId: tasksArr,
          ...(usersSuperId !== 'none' && { userId: usersSuperId }),
        });
        enqueueSnackbar('Entry added successfully', { variant: 'success' });
        // Keep form open, shift times to continue sequential entry
        const nextFrom = formTimeToStr;
        setFormTimeFromStr(nextFrom);
        setFormTimeToStr(addOneHour(nextFrom));
        setFormDescription('');
        setFormErrors({});
        setIsEditing(false);
        setEditRowId(null);
        updateReports();
        setButtonAdd(false);
        return;
      }
      updateReports();
      resetForm();
    } catch {
      enqueueSnackbar(isEditing ? 'Error updating entry' : 'Error adding entry', { variant: 'error' });
    } finally {
      setButtonAdd(false);
    }
  };

  // ── Update reports ──
  const updateReports = useCallback(async () => {
    setLoading(true);
    try {
      let updatedReports;
      if (usersSuperId === 'none') {
        const { data } = await axios.get('/time-reports');
        updatedReports = data;
      } else {
        const { data } = await axios.post('/time-reports/reports/sub', { userId: usersSuperId });
        updatedReports = data;
      }
      setReports(updatedReports);
    } catch { } finally {
      setLoading(false);
      setButtonAdd(false);
    }
  }, [usersSuperId]);

  const handleChangeAll = (event: React.SyntheticEvent, newValue: string) => setTabValue(newValue);

  useEffect(() => {
    // Only trigger on tab switch — usersSuperId changes are handled by the main data-load effect
    if (tabValue === 'timesheets') updateReports();
    if (tabValue === 'toil' && toilContracts.length === 0) {
      axios.get('hr-schedule-template').then(({ data }) => setToilContracts(data)).catch(() => {});
    }
  }, [tabValue]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Sort & filter reports — memoized so they don't recalculate on every render ──
  const sortedReports = useMemo(() =>
    reports?.slice().sort((a, b) => {
      const dateA = moment((a as Report).date);
      const dateB = moment((b as Report).date);
      if (dateA.isSame(dateB, 'day')) {
        const timeA = moment((a as Report).startTime);
        const timeB = moment((b as Report).startTime);
        return timeA.isBefore(timeB) ? -1 : timeA.isAfter(timeB) ? 1 : 0;
      }
      return dateA.isBefore(dateB) ? -1 : 1;
    }),
  [reports]);

  const { rows, sum } = useMemo(() => {
    let total = 0;
    const mapped = sortedReports?.filter((item: any) =>
      transformedWeek.includes(moment(item.date).format('DD.MM.YYYY'))
    ).map((item: any) => {
      const startTime = moment(item.startTime);
      const endTime   = moment(item.endTime);
      const diffInMinutes = endTime.diff(startTime, 'minutes');
      const roundedMinutes = Math.ceil(diffInMinutes / 5) * 5;
      total += roundedMinutes;
      return {
        id: item.id,
        date: item.date,
        startTime: item.startTime,
        endTime: item.endTime,
        categoryid: item.categoryId,
        description: item.description,
        dateId: item.id,
        status: item.status,
        tasks: item.tasks,
        supervisorId: item.supervisorId,
        supervisor: item.supervisor,
        categoryTree: `${item.categoryTree}`,
        supervisorFirstName: item.supervisor?.first_name,
        supervisorLastName: item.supervisor?.last_name,
        allTime: `${Math.floor(roundedMinutes / 60)}:${(roundedMinutes % 60).toFixed(0).padStart(2, '0')}`,
      };
    }) ?? [];
    return { rows: mapped, sum: total };
  }, [sortedReports, transformedWeek]);

  // Returns default { from, to } for a day based on existing rows or pattern
  const getDefaultTimesForDay = useCallback((dayIdx: number): { from: string; to: string } => {
    const day = week[dayIdx];
    if (!day) return { from: '09:00', to: '10:00' };
    const dayStr = dayjs(day).format('YYYY-MM-DD');

    const dayRows = rows.filter((r: any) => moment(r.date).format('YYYY-MM-DD') === dayStr);
    if (dayRows.length > 0) {
      const sorted = dayRows.slice().sort((a: any, b: any) => moment(a.endTime).diff(moment(b.endTime)));
      const lastEnd = moment.utc(sorted[sorted.length - 1].endTime).format('HH:mm');
      return { from: lastEnd, to: addOneHour(lastEnd) };
    }

    if (userPattern?.days?.length === 7) {
      const iso = dayjs(day).isoWeekday(); // 1=Mon, 7=Sun
      const pDay = userPattern.days[iso - 1];
      if (pDay && !pDay.dayOff && pDay.start) {
        return { from: pDay.start, to: addOneHour(pDay.start) };
      }
    }

    return { from: '09:00', to: '10:00' };
  }, [week, rows, userPattern]); // eslint-disable-line

  // Auto-populate times when day changes while add-form is open (not editing)
  useEffect(() => {
    if (!showInlineForm || isEditing) return;
    const { from, to } = getDefaultTimesForDay(formDayIndex);
    setFormTimeFromStr(from);
    setFormTimeToStr(to);
  }, [formDayIndex, startDate, showInlineForm]); // eslint-disable-line

  // Group by date — memoized
  const groupedRows = useMemo(() => {
    const grouped: { [key: string]: any[] } = {};
    rows.forEach(row => {
      const date = moment(row.date).format('YYYY-MM-DD');
      if (!grouped[date]) grouped[date] = [];
      grouped[date].push(row);
    });
    return grouped;
  }, [rows]);

  // Per-day totals map — computed once instead of reduce × 5 in sidebar
  const dayTotalsMap = useMemo(() => {
    const map: Record<string, number> = {};
    rows.forEach((r: any) => {
      const dayStr = moment(r.date).format('YYYY-MM-DD');
      const [h, m] = r.allTime.split(':').map(Number);
      map[dayStr] = (map[dayStr] || 0) + h * 60 + m;
    });
    return map;
  }, [rows]);

  const isStartDateInCurrentWeek = () =>
    !rows.some(r => r.status === 'pending' || r.status === 'rejected' || r.status === 'fulfilled');

  // ── Submit / Return ──
  const changeReportStatus = async (reportIds: any, statusReport: string) => {
    try {
      await axios.put('/time-reports/update-status', { reportsId: reportIds, status: statusReport });
      enqueueSnackbar('Status updated successfully', { variant: 'success' });
    } catch (error: any) {
      const msg = error.response?.data?.message;
      const errText = statusReport !== 'new'
        ? (Array.isArray(msg) ? 'Time entries overlap. Please fix overlapping entries before submitting.' : (msg || 'Error changing status'))
        : 'Error returning week';
      enqueueSnackbar(errText, { variant: 'error' });
      if (statusReport !== 'new') throw error;
    }
  };

  const sendToApprove = async () => {
    setLoading(true); setShowAprove(false);
    try {
      const ids = rows.filter(r => r.status !== 'fulfilled' && r.status !== 'pending').map((r: any) => r.dateId);
      if (ids.length > 0) await changeReportStatus(ids, 'pending');
      const { data } = await (usersSuperId === 'none' ? axios.get('user') : axios.post('user/sub', { userId: usersSuperId }));
      if (data) setToils(data.totalToils);
      updateReports();
    } catch { } finally { setLoading(false); }
  };

  const sendReturnWeek = async () => {
    setLoadingWeek(true); setReturnWeek(false);
    try {
      const ids = rows.map((r: any) => r.dateId);
      if (ids.length > 0) await changeReportStatus(ids, 'new');
      const { data } = await (usersSuperId === 'none' ? axios.get('user') : axios.post('user/sub', { userId: usersSuperId }));
      if (data) setToils(data.totalToils);
      updateReports();
    } catch { } finally { setLoadingWeek(false); }
  };

  // ── Delete ──
  const deleteReport = async (id: number) => {
    try {
      await axios.post(`/time-reports/delete-reports/${id}`);
      updateReports();
      enqueueSnackbar('Entry deleted', { variant: 'success' });
    } catch { enqueueSnackbar('Error deleting entry', { variant: 'error' }); }
  };

  const bulkDeleteSelected = async () => {
    try {
      await Promise.all((selected as number[]).map(id => axios.post(`/time-reports/delete-reports/${id}`)));
      setSelected([]);
      updateReports();
      enqueueSnackbar(`${selected.length} entries deleted`, { variant: 'success' });
    } catch { enqueueSnackbar('Error deleting entries', { variant: 'error' }); }
  };

  const toggleSelect = (id: number) => {
    setSelected(prev =>
      (prev as number[]).includes(id) ? (prev as number[]).filter(x => x !== id) : [...(prev as number[]), id]
    );
  };

  // ── Initial data load ──
  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        // Parallel: user data + static lists + reports + templates
        const userReq = usersSuperId === 'none'
          ? axios.get('user')
          : axios.post('user/sub', { userId: usersSuperId });
        const reportsReq = usersSuperId === 'none'
          ? axios.get('/time-reports')
          : axios.post('/time-reports/reports/sub', { userId: usersSuperId });
        const templateReq = usersSuperId === 'none'
          ? axios.get('template/user/group')
          : axios.post('template/user/group/sub', { userId: usersSuperId });

        const usersEndpoint = access?.timesheet_view_all
          ? 'users'
          : access?.timesheet_view_dep
            ? 'users/team'
            : null;

        const [
          { data: userData },
          { data: categoryData },
          superUsersRes,
          { data: reportsData },
          { data: templateData },
        ] = await Promise.all([userReq, axios.get('category'), usersEndpoint ? axios.get(usersEndpoint) : Promise.resolve({ data: [] }), reportsReq, templateReq]);

        if (userData) {
          setToils(userData.totalToils);
          setPerWeek(userData.pattern?.hoursPerWeek ?? 0);
          setUserInfo(userData.id);
          setUserPattern(userData.pattern ?? null);
        }
        setAllTemplateSelect(templateData);
        setReports(reportsData);
        setUsers(superUsersRes.data);
        setAllCategory(categoryData);
        setCategory(transformToHierarchyCallback(categoryData.filter((c: any) => c.status !== 'inactive')));
      } catch { } finally { setLoading(false); }
    })();
  }, [dispatch, transformToHierarchyCallback, location.pathname, usersSuperId]);

  const refreshCategory = async () => {
    try {
      const { data } = await axios.get('category');
      setAllCategory(data);
      setCategory(transformToHierarchyCallback(data.filter((c: any) => c.status !== 'inactive')));
    } catch { }
  };

  useEffect(() => {
    if (dayPick) {
      const selectedDay = dayPick.toDate();
      setStartDate(moment(selectedDay).set({ hour: 12, minute: 0, second: 0, millisecond: 0 }).toDate());
    }
  }, [week, dayPick]);

  // Sync form day when week changes
  useEffect(() => {
    if (week.length > 0) {
      setStartDate(moment(week[0].toDate()).set({ hour: 12, minute: 0, second: 0 }).toDate());
      setFormDayIndex(0);
    }
  }, [week]);

  const handleApplyFromPanel = useCallback(async (groupNumber: string, entryIds?: number[]) => {
    const hasInvalidStatus = Object.values(rows).some(
      (row: any) => row.status === 'pending' || row.status === 'fulfilled',
    );
    if (hasInvalidStatus) {
      enqueueSnackbar(t('CannotAddTemplate') || 'Cannot add template: some rows have status pending or fulfilled', { variant: 'error' });
      return;
    }
    try {
      await axios.post('time-reports/template', {
        firstDayWeek: moment(week[0].toDate()).startOf('isoWeek').format('YYYY-MM-DD'),
        temp_group_number: Number(groupNumber),
        ...(usersSuperId !== 'none' && { userId: Number(usersSuperId) }),
        ...(entryIds && entryIds.length > 0 && { entryIds }),
      });
      updateReports();
      setSelectedIndex(-1);
      enqueueSnackbar(t('Add') || 'Template applied', { variant: 'success' });
    } catch {
      enqueueSnackbar('Error applying template', { variant: 'error' });
    }
  }, [rows, week, usersSuperId, enqueueSnackbar, updateReports]);

  const fixPerWeek = Number(perWeek) * 60;
  const convertToHoursAndMinutes = (v: any) => {
    const isNeg = v < 0;
    const abs = Math.abs(v);
    const h = Math.trunc(abs);
    const m = Math.round((abs - h) * 60);
    return `${isNeg ? '-' : ''}${h}:${m.toString().padStart(2, '0')}`;
  };

  const fmtMin = (m: number) => !m ? '—' : `${Math.floor(m / 60)}h${m % 60 ? ` ${m % 60}m` : ''}`;

  // ── Helpers ──
  const weekHasPending      = rows.some(r => r.status === 'pending' || r.status === 'fulfilled');
  const weekHasRejected     = rows.some(r => r.status === 'rejected');
  // All entries rejected (no pending/fulfilled) — employee must resubmit
  const weekAllRejected     = weekHasRejected && !weekHasPending;
  const canReturnWeek       = access.timesheet_return_week && rows.length > 0;
  const [toilContracts, setToilContracts]     = useState<{id: number; name: string}[]>([]);
  const [toilFilters, setToilFilters]         = useState<ActiveFilter[]>([]);
  const [toilCalOffset, setToilCalOffset]     = useState(0);
  const [toilSearch, setToilSearch]           = useState('');
  const [toilPeriodLabel, setToilPeriodLabel] = useState('');

  // Contract — во встроенном фильтре SearchFilter (одно значение); ToilCalendar ждёт number[]
  const toilContractVal = toilFilters.find(f => f.colKey === 'contract')?.value;
  const toilContractFilter = toilContractVal ? [Number(toilContractVal)] : [];
  const toilFilterColumns: ColDef[] = React.useMemo(() => toilContracts.length ? [{
    key: 'contract', label: t('Contract') || 'Contract', render: () => null, filterType: 'select',
    filterOptions: toilContracts.map(c => ({ value: String(c.id), label: c.name })),
  }] : [], [toilContracts]);
  const toilPickerWeek = React.useMemo<Dayjs[]>(() => {
    const TOIL_W = 8;
    const mon = getMondayOf(dayjs().startOf('isoWeek' as any).subtract(toilCalOffset * TOIL_W, 'week').toDate());
    return buildWeekFromMonday(mon);
  }, [toilCalOffset]);
  const handleToilPickerSelect = (newWeek: Dayjs[]) => {
    const diff = dayjs().startOf('isoWeek' as any).diff(newWeek[0], 'week');
    setToilCalOffset(Math.max(0, Math.floor(diff / 8)));
  };
  const [sidebarCollapsed, setSidebarCollapsed] = useState<Set<string>>(new Set());
  const toggleSidebar = (key: string) => setSidebarCollapsed(prev => {
    const next = new Set(prev);
    if (next.has(key)) next.delete(key); else next.add(key);
    return next;
  });

  /* ────────────────────────── RENDER ────────────────────────── */
  return (
    <div className="section-page">
      {/* Subordinate indicator */}
      {usersSuperId !== 'none' && (
        <div className="absolute right-[20px] text-red-500 opacity-80 text-[13px]">
          {users?.filter((u: any) => u.id === Number(usersSuperId)).map((u: any) => (
            <span key={(u as any).id}>{t('You are currently under')}: {(u as any).first_name} {(u as any).last_name}</span>
          ))}
        </div>
      )}

      <Box sx={{ width: '100%' }}>

        {/* ─── V10 Sticky tab header ─── */}
        <div style={{
          position: 'sticky', top: 0, zIndex: 100,
          background: 'transparent',
          borderBottom: '1px solid rgba(var(--shodow), 0.08)',
          display: 'flex', alignItems: 'stretch', justifyContent: 'space-between',
          gap: 8, flexWrap: 'nowrap',
        }}>
          {/* Left: tabs */}
          <div style={{ display: 'flex', flexShrink: 0 }}>
            {([
              { label: t('Timesheets'), value: 'timesheets', show: true, disabled: false },
              { label: t('Approvals'),  value: 'approvals', show: !!access.timesheet_approve_enabled, disabled: usersSuperId !== 'none' },
              // Templates tab removed — шаблоны доступны через кнопку в тулбаре
              { label: t('Reports'),   value: 'reports_new', show: !!access.timesheet_reports_enabled, disabled: false },
              { label: 'TOIL',         value: 'toil',       show: !!access.toil_enabled,              disabled: false },
            ] as { label: string; value: string; show: boolean; disabled: boolean }[])
              .filter(tab => tab.show)
              .map(tab => (
                <button
                  key={tab.value}
                  type="button"
                  disabled={tab.disabled}
                  onClick={() => !tab.disabled && handleChangeAll({} as React.SyntheticEvent, tab.value)}
                  style={{
                    padding: '10px 18px', fontSize: 12,
                    fontWeight: tabValue === tab.value ? 800 : 600,
                    border: 'none', background: 'transparent',
                    color: tabValue === tab.value ? 'var(--text-color)' : 'var(--text-color-calendar-week)',
                    position: 'relative', cursor: tab.disabled ? 'not-allowed' : 'pointer',
                    opacity: tab.disabled ? 0.4 : 1,
                    transition: 'color .15s', whiteSpace: 'nowrap',
                  }}
                >
                  {tab.label}
                  {tabValue === tab.value && (
                    <span style={{
                      position: 'absolute', bottom: 0, left: 12, right: 12, height: 3,
                      background: 'linear-gradient(90deg,#2563eb,#7c3aed)',
                      borderRadius: '3px 3px 0 0',
                      display: 'block',
                    }} />
                  )}
                </button>
              ))}
          </div>

          {/* Right: settings — always visible */}
          {access.timesheet_settings && (
            <div style={{ display: 'flex', alignItems: 'center', padding: '0 8px' }}>
              <Tooltip title={t('Settings')} placement="left">
                <FontAwesomeIcon
                  icon={faGear}
                  className="transition-transform duration-500 cursor-pointer opacity-60 hover:rotate-180 hover:opacity-90 text-[var(--text-color)] mr-[4px]"
                  onClick={() => setSettingsOpen(true)}
                />
              </Tooltip>
            </div>
          )}
        </div>

        <TabContext value={tabValue}>

          {/* ═══════════════════════════════════════
              TIMESHEETS TAB — new design
          ═══════════════════════════════════════ */}
          <TabPanel value="timesheets" sx={{ padding: 'var(--space-l1) 0' }}>
            {auth ? (
              <div style={{ display: 'flex', gap: 'var(--space-l1)', alignItems: 'stretch', flex: 1, minHeight: 0, overflow: 'hidden' }}>

                {/* ── LEFT: main content ── */}
                <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 'var(--space-l1)', height: '100%', overflow: 'hidden' }}>

                  {/* ── Week nav + controls ── */}
                  <PageToolbar mb={0}>
                    {/* Left: arrows + label + calendar + Today + Add */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <button type="button" onClick={prevWeek}
                        className="bg-[var(--btn-user-form)] border border-[var(--border-input)] text-[var(--text-color)] rounded-[8px]"
                        style={{ width: 32, height: 32, cursor: 'pointer', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>‹</button>
                      <div>
                        <div style={{ fontSize: 14, fontWeight: 900, color: 'var(--text-color)', letterSpacing: '-.02em' }}>{weekLabel}</div>
                        <div style={{ fontSize: 10, color: 'var(--text-color-calendar-week)', marginTop: 1 }}>
                          ISO Week {weekIso} · <span style={{ color: sum / 60 >= Number(perWeek) ? '#059669' : '#d97706', fontWeight: 800 }}>
                            {Math.floor(sum / 60)}:{(sum % 60).toFixed(0).padStart(2, '0')}h of {perWeek}h
                          </span>
                        </div>
                      </div>
                      <button type="button" onClick={nextWeek}
                        className="bg-[var(--btn-user-form)] border border-[var(--border-input)] text-[var(--text-color)] rounded-[8px]"
                        style={{ width: 32, height: 32, cursor: 'pointer', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>›</button>
                      <button type="button" onClick={goToday}
                        className="bg-[var(--btn-user-form)] border border-[var(--border-input)] text-[var(--text-color)] rounded-[8px]"
                        style={{ height: 32, padding: '0 10px', fontSize: 12, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                        Today
                      </button>
                      {/* Add Entry */}
                      <button type="button"
                        disabled={weekHasPending}
                        title={weekHasPending ? 'Return the week first to add new entries' : undefined}
                        onClick={() => {
                          if (!showInlineForm) {
                            // Ставим сегодняшнюю дату по умолчанию
                            const todayIdx = week.findIndex(d => dayjs(d).isSame(dayjs(), 'day'));
                            const idx = todayIdx >= 0 ? todayIdx : 0;
                            setFormDayIndex(idx);
                            if (week[idx]) setStartDate(moment(week[idx].toDate()).set({ hour: 12, minute: 0, second: 0 }).toDate());
                            setIsEditing(false);
                            setEditRowId(null);
                            // Refresh categories only if not yet loaded
                            if (category.length === 0) refreshCategory();
                          }
                          setShowInlineForm(p => !p);
                        }}
                        style={{ height: 32, padding: '0 14px', borderRadius: 8, border: 'none', background: weekHasPending ? 'var(--btn-user-form)' : 'linear-gradient(135deg,#2563eb,#7c3aed)', color: weekHasPending ? 'var(--text-color-calendar-week)' : 'white', fontSize: 11, fontWeight: 700, cursor: weekHasPending ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: 'var(--space-l3)', boxShadow: weekHasPending ? 'none' : '0 3px 10px rgba(37,99,235,.25)', opacity: weekHasPending ? 0.5 : 1 }}>
                        <svg width="10" height="10" viewBox="0 0 14 14" fill="none"><path d="M7 1v12M1 7h12" stroke="white" strokeWidth="2.2" strokeLinecap="round"/></svg>
                        {t('AddReport')}
                      </button>
                    </div>

                    {/* Spacer — pushes right buttons to far right */}
                    <div style={{ flex: 1 }} />

                    {/* Right: Return week + user select + Templates */}
                    {(access.timesheet_view_all || access.timesheet_view_dep) && (
                      (() => {
                        const selfOptions = [
                          { value: 'none', label: 'Self' },
                          ...(users ?? [])
                            .filter((u: any) => u.id !== userInfo)
                            .sort((a: any, b: any) => a.first_name.localeCompare(b.first_name))
                            .map((u: any) => ({ value: String(u.id), label: `${u.first_name} ${u.last_name}` })),
                        ];
                        return (
                          <Select
                            value={selfOptions.find(o => o.value === (usersSuperId || 'none'))}
                            onChange={(opt: any) => { setUsersSuperId(opt?.value ?? 'none'); setSelected([]); }}
                            options={selfOptions}
                            styles={selfSelectStyles}
                            isSearchable={selfOptions.length > 8}
                            menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
                            classNamePrefix="app-rs"
                          />
                        );
                      })()
                    )}
                    {canReturnWeek && (
                      <button type="button"
                        onClick={() => !loadingWeek && setReturnWeek(true)}
                        disabled={loadingWeek}
                        style={{ height: 32, padding: '0 11px', borderRadius: 8, border: '1px solid rgba(217,119,6,.28)', background: 'rgba(217,119,6,.1)', color: '#d97706', fontSize: 11, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 'var(--space-l3)' }}>
                        {loadingWeek ? <CircularProgress size={11} color="inherit" /> : '↩ ' + t('ReturnWeek')}
                      </button>
                    )}
                    {access.timesheet_template && (
                      <button type="button"
                        onClick={() => { setPendingTemplateEntries([]); setShowTemplatesPanel(true); }}
                        style={{ height: 32, padding: '0 10px', borderRadius: 8, border: showTemplatesPanel ? '1px solid rgba(124,58,237,.4)' : '1px solid var(--border-input)', background: showTemplatesPanel ? 'rgba(124,58,237,.08)' : 'var(--btn-user-form)', color: showTemplatesPanel ? '#7c3aed' : 'var(--text-color)', fontSize: 11, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 'var(--space-l3)', transition: 'all .15s' }}>
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
                        {t('Templates') || 'Templates'}
                      </button>
                    )}

                  </PageToolbar>

                  {/* ── Inline add / edit form ── */}
                  {showInlineForm && (
                    <div className="ts-card tm-scope" style={{ flexShrink: 0, overflow: 'visible' }}>
                      <div style={{
                        display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap',
                        padding: '8px 12px',
                      }}>
                      {/* Режим — Edit или Add */}
                      {isEditing && (
                        <span style={{ fontSize: 11, fontWeight: 700, color: '#2563eb', flexShrink: 0, whiteSpace: 'nowrap' }}>
                          ✏ {t('Edit') || 'Edit'}
                        </span>
                      )}
                      {/* Date */}
                      <Select
                        menuPortalTarget={document.body}
                        styles={daySelectStyles}
                        isSearchable={false}
                        value={{ value: formDayIndex, label: week[formDayIndex]?.format('ddd, D MMM') ?? '' }}
                        onChange={(opt: any) => {
                          if (!opt) return;
                          const idx = opt.value;
                          setFormDayIndex(idx);
                          if (week[idx]) setStartDate(moment(week[idx].toDate()).set({ hour: 12, minute: 0, second: 0 }).toDate());
                        }}
                        options={week.map((d, i) => ({ value: i, label: d.format('ddd, D MMM') }))}
                      />

                      <div style={{ width: 1, height: 20, background: 'var(--border-input)', flexShrink: 0 }} />

                      {/* From → To — строго по шагу компании */}
                      <TimePicker
                        mode="range"
                        output="string"
                        from={formTimeFromStr}
                        to={formTimeToStr}
                        onChange={(f: any, tt: any) => { setFormTimeFromStr(f); setFormTimeToStr(tt); setFormErrors(p => ({ ...p, time: false })); }}
                        step={getCompanyTimeStep()}
                        className={formErrors.time ? 'tp-err' : ''}
                      />

                      {/* Duration pill */}
                      {(() => {
                        const [fh, fm] = formTimeFromStr.split(':').map(Number);
                        const [th, tm] = formTimeToStr.split(':').map(Number);
                        let mins = th * 60 + tm - fh * 60 - fm;
                        if (mins < 0) mins += 1440; // overnight
                        const h = Math.floor(mins / 60), m = mins % 60;
                        const label = mins > 0 ? `${h}:${String(m).padStart(2, '0')}h` : '—';
                        return (
                          <span style={{
                            padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 900,
                            fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap',
                            background: mins > 0 ? 'rgba(37,99,235,.1)' : 'rgba(239,68,68,.08)',
                            border: `1px solid ${mins > 0 ? 'rgba(37,99,235,.18)' : 'rgba(239,68,68,.15)'}`,
                            color: mins > 0 ? '#2563eb' : '#dc2626',
                          }}>{label}</span>
                        );
                      })()}

                      <div style={{ width: 1, height: 20, background: 'var(--border-input)', flexShrink: 0 }} />

                      {/* Category + Task — NEW picker */}
                      <CategoryTaskPicker
                        nodes={category}
                        selectedCategoryId={selectedCategoryId}
                        categoryName={categoryName}
                        onCategorySelect={(id, name) => {
                          if (id === -1) { setCategoryName([]); setSelectedCategoryId([]); setTest(undefined); return; }
                          setSelectedCategoryId([id]);
                          setCategoryName(name as any);
                          setTest(id);
                          setFormErrors(p => ({ ...p, category: false, task: false }));
                        }}
                        selectedTasks={selectedTasks}
                        setSelectedTasks={tasks => { setSelectedTasks(tasks); if (tasks.length) setFormErrors(p => ({ ...p, task: false })); }}
                        taskOrTasks={taskOrTasks}
                        formError={formErrors.category || formErrors.task}
                        onErrorClear={() => setFormErrors(p => ({ ...p, category: false, task: false }))}
                      />

                      {/* OLD Category — закомментировано, заменено CategoryTaskPicker выше
                      <div style={{ position: 'relative', flexShrink: 0 }}>
                        <div
                          className="edit-input rounded-[8px] cursor-pointer"
                          style={{ height: 32, padding: '0 9px', fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 'var(--space-l3)', minWidth: 160, whiteSpace: 'nowrap', ...(formErrors.category ? { borderColor: '#dc2626', background: 'rgba(220,38,38,.06)' } : {}) }}
                          onClick={(e) => { handleClickCategoryBox(e); setFormErrors(p => ({ ...p, category: false })); }}>
                          <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', color: categoryName.length ? 'var(--text-color)' : 'var(--text-color-calendar-week)' }}>
                            {categoryName.length ? categoryName : t('SelectCategory')}
                          </span>
                          <FontAwesomeIcon icon={faChevronDown} style={{ fontSize: 10, opacity: .5, flexShrink: 0 }} />
                        </div>
                        {isCategoryListVisible && (
                          <div
                            className="absolute top-[38px] left-0 z-[999] py-[5px] bg-[var(--bg-form)] rounded-[8px]"
                            style={{ width: 260, border: '1px solid var(--border-input)', boxShadow: '0 8px 24px rgba(0,0,0,.18)', maxHeight: 280, overflowY: 'auto' }}
                            onClick={handleCategoryListClick}>
                            <TreeViewComponent
                              nodes={category}
                              onNodeSelect={handleNodeSelect}
                              updateTree=""
                              openCheckModal={openCheckModal}
                              selectedCategoryId=""
                              wordsSecret="" />
                          </div>
                        )}
                      </div>
                      */}

                      {/* OLD Task — закомментировано, заменено CategoryTaskPicker выше
                      <div style={{ minWidth: 160, flexShrink: 0, borderRadius: 8, ...(formErrors.task ? { outline: '1.5px solid #dc2626', boxShadow: '0 0 0 2px rgba(220,38,38,.08)' } : {}) }}
                        onClick={() => setFormErrors(p => ({ ...p, task: false }))}>
                        <SelectTask
                          test={test}
                          setSelectedTasks={setSelectedTasks}
                          selectedTasks={selectedTasks}
                          taskOrTasks={taskOrTasks}
                        />
                      </div>
                      */}

                      {/* Notes */}
                      <input
                        className="edit-input rounded-[8px] text-[var(--text-color)]"
                        style={{ height: 32, flex: .9, minWidth: 72, padding: '0 9px', fontSize: 12 }}
                        placeholder="Notes"
                        value={formDescription}
                        onChange={e => setFormDescription(e.target.value)}
                        onKeyDown={e => { if (e.key === 'Enter') handleAddClick(); if (e.key === 'Escape') setShowInlineForm(false); }}
                      />

                      {/* Add — прижат вправо */}
                      <button type="button"
                        style={{ height: 32, padding: '0 16px', borderRadius: 9, border: 'none', background: 'linear-gradient(135deg,#059669,#0d9488)', color: 'white', fontSize: 12, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0, boxShadow: '0 2px 8px rgba(5,150,105,.25)', marginLeft: 'auto' }}
                        onClick={handleAddClick}
                        disabled={buttonAdd}>
                        {buttonAdd ? <CircularProgress size={12} color="inherit" /> : isEditing ? (t('Save') || 'Save') : t('Add')}
                      </button>
                      </div>{/* /scrollable inner row */}
                    </div>
                  )}

                  {/* ── Entries list card ── */}
                  <div className="ts-card" style={{ overflow: 'hidden', flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
                    data-scroll-container="entries">

                    {/* Bulk action bar */}
                    {selected.length > 0 && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 16px', background: 'rgba(37,99,235,.07)', borderBottom: '1px solid rgba(37,99,235,.15)' }}>
                        <span style={{ fontSize: 12, fontWeight: 800, color: '#2563eb' }}>{selected.length} {t('Selected')}</span>
                        <span style={{ flex: 1 }} />
                        <button type="button"
                          style={{ padding: '5px 14px', borderRadius: 8, border: '1px solid rgba(239,68,68,.25)', background: 'rgba(239,68,68,.1)', color: '#dc2626', fontSize: 11, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}
                          onClick={bulkDeleteSelected}>
                          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/></svg>
                          {t('Delete')}
                        </button>
                        {access.timesheet_template && (
                          <button type="button"
                            style={{ padding: '5px 14px', borderRadius: 8, border: '1px solid rgba(124,58,237,.25)', background: 'rgba(124,58,237,.09)', color: '#7c3aed', fontSize: 11, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}
                            onClick={() => {
                              const selectedRows = rows.filter(r => (selected as number[]).includes(r.id));
                              setPendingTemplateEntries(selectedRows.map(report => ({
                                selectedDay: moment(report.date).isoWeekday(),
                                startTime: moment(report.startTime).format('HH:mm'),
                                endTime: moment(report.endTime).format('HH:mm'),
                                categoryId: report.categoryid,
                                tasksId: report.tasks.map((task: any) => ({ value: task.id, label: task.name || task.label || '' })),
                                description: report.description || '',
                              })));
                              setShowTemplatesPanel(true);
                            }}>
                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
                            {t('CreateWeekTemplate')}
                          </button>
                        )}
                        <button type="button"
                          style={{ padding: '5px 10px', borderRadius: 8, border: '1px solid var(--border-input)', background: 'var(--btn-user-form)', color: 'var(--text-color-calendar-week)', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}
                          onClick={() => setSelected([])}>✕</button>
                      </div>
                    )}

                    <div style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
                    {loading ? (
                      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 180 }}>
                        <CircularProgress />
                      </Box>
                    ) : rows.length === 0 ? (
                      <EmptyState message={t('Empty') as string} />
                    ) : (
                      Object.entries(groupedRows).map(([dateStr, dayRows]) => {
                        const dayMoment = moment(dateStr);
                        const isToday   = dayMoment.isSame(moment(), 'day');
                        const dayTotalM = dayRows.reduce((acc, r) => {
                          const [h, m] = r.allTime.split(':').map(Number);
                          return acc + h * 60 + m;
                        }, 0);
                        const dayTotalLabel = dayTotalM ? `${Math.floor(dayTotalM / 60)}:${(dayTotalM % 60).toFixed(0).padStart(2, '0')}h` : '—';

                        return (
                          <React.Fragment key={dateStr}>
                            {/* Day header */}
                            <div style={{
                              display: 'flex', alignItems: 'center', gap: 10,
                              padding: '9px 16px 7px',
                              background: 'var(--bg-top)',
                              borderBottom: 'var(--border-input)',
                              fontSize: 10, fontWeight: 800, letterSpacing: '.07em', textTransform: 'uppercase',
                              color: isToday ? '#2563eb' : 'var(--text-color-calendar-week)',
                            }}>
                              <span>{dayMoment.format('dddd, D MMM')}{isToday ? ' · Today' : ''}</span>
                              <span style={{ flex: 1 }} />
                              <span style={{ fontSize: 11, fontWeight: 900, color: dayTotalM >= fixPerWeek / 5 ? '#059669' : '#d97706', textTransform: 'none', letterSpacing: 0 }}>{dayTotalLabel}</span>
                            </div>

                            {/* Entries */}
                            {dayRows.map((row: any) => {
                              const isChecked = (selected as number[]).includes(row.id);
                              const timeFrom_ = moment(row.startTime).format('HH:mm');
                              const timeTo_   = moment(row.endTime).format('HH:mm');
                              const breadcrumb = (row.categoryTree || '').replace(/ > /g, ' › ');
                              const taskNames  = row.tasks?.map((tk: any) => tk.name || tk.label).filter(Boolean).join(', ');

                              const statusBg: Record<string, string> = {
                                pending:   'linear-gradient(90deg,rgba(217,119,6,.18) 0%,rgba(217,119,6,.06) 120px,rgba(217,119,6,.05) 100%)',
                                fulfilled: 'linear-gradient(90deg,rgba(5,150,105,.18) 0%,rgba(5,150,105,.06) 120px,rgba(5,150,105,.05) 100%)',
                                rejected:  'linear-gradient(90deg,rgba(220,38,38,.16) 0%,rgba(220,38,38,.06) 120px,rgba(220,38,38,.05) 100%)',
                              };
                              const rowBg = isChecked
                                ? 'rgba(37,99,235,.04)'
                                : statusBg[row.status] ?? 'var(--btn-user-form)';

                              return (
                                <div
                                  key={row.id}
                                  style={{
                                    display: 'grid',
                                    gridTemplateColumns: '36px 10px 1fr auto auto auto',
                                    alignItems: 'center',
                                    padding: '0 16px',
                                    minHeight: 52,
                                    borderBottom: 'var(--border-input-one)',
                                    gap: 12,
                                    background: rowBg,
                                    cursor: 'default',
                                    transition: 'background .1s',
                                  }}
                                  onMouseEnter={e => { if (!isChecked) (e.currentTarget as HTMLElement).style.background = 'var(--bg-top)'; }}
                                  onMouseLeave={e => { if (!isChecked) (e.currentTarget as HTMLElement).style.background = rowBg; }}
                                >
                                  {/* Checkbox */}
                                  <div
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                                    onClick={() => toggleSelect(row.id)}>
                                    <div style={{
                                      width: 16, height: 16, borderRadius: 4, flexShrink: 0,
                                      border: isChecked ? 'none' : 'var(--border-input)',
                                      background: isChecked ? '#2563eb' : 'transparent',
                                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                                      transition: 'all .12s',
                                    }}>
                                      {isChecked && <span style={{ fontSize: 9, fontWeight: 900, color: 'white' }}>✓</span>}
                                    </div>
                                  </div>

                                  {/* Color dot */}
                                  <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#2563eb', flexShrink: 0 }} />

                                  {/* Entry info */}
                                  <div style={{ minWidth: 0, padding: '10px 0' }}>
                                    {/* Breadcrumb path */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 4 }}>
                                      <span style={{ fontSize: 13, fontWeight: 800, color: 'var(--text-color)' }}>
                                        {breadcrumb}
                                      </span>
                                      {taskNames && (
                                        <>
                                          <span style={{ fontSize: 11, color: 'var(--text-color-calendar-week)' }}>›</span>
                                          <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-color-calendar)' }}>{taskNames}</span>
                                        </>
                                      )}
                                    </div>
                                    {/* Time range + description */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                                      <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-color-calendar)', fontVariantNumeric: 'tabular-nums' }}>
                                        {timeFrom_}
                                        <span style={{ color: 'var(--text-color-calendar-week)', fontSize: 11, margin: '0 3px' }}>→</span>
                                        {timeTo_}
                                      </span>
                                      {row.description && (
                                        <span style={{ fontSize: 11, color: 'var(--text-color-calendar-week)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 300 }}>
                                          {row.description}
                                        </span>
                                      )}
                                    </div>
                                  </div>

                                  {/* Duration */}
                                  <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-color)', fontVariantNumeric: 'tabular-nums', flexShrink: 0, textAlign: 'right' }}>
                                    {row.allTime}<span style={{ fontSize: 10, fontWeight: 500, color: 'var(--text-color-calendar-week)', marginLeft: 1 }}>h</span>
                                  </div>

                                  {/* Status + Supervisor */}
                                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4, flexShrink: 0 }}>
                                    <StatusBadge status={row.status} />
                                    {(row.supervisorFirstName || row.supervisorLastName) && (
                                      <span style={{ fontSize: 10, color: 'var(--text-color-calendar-week)', whiteSpace: 'nowrap' }}>
                                        {row.supervisorFirstName} {row.supervisorLastName}
                                      </span>
                                    )}
                                  </div>

                                  {/* Actions */}
                                  <div style={{ display: 'flex', gap: 4, flexShrink: 0 }} onClick={e => e.stopPropagation()}>
                                    <button type="button" className="btn-icon" onClick={() => handleEditClick(row)}>✏️</button>
                                    <button type="button" className="btn-icon danger" onClick={() => deleteReport(row.id)}>🗑</button>
                                  </div>
                                </div>
                              );
                            })}
                          </React.Fragment>
                        );
                      })
                    )}
                    </div>{/* end scroll wrapper */}
                  </div>
                </div>

                {/* ── RIGHT: sidebar ── */}
                <div style={{ width: 260, flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 12, overflowY: 'auto', alignSelf: 'stretch', scrollbarWidth: 'thin', scrollbarColor: 'var(--border-input) transparent' }}>

                  {/* Week overview */}
                  <div className="ts-card" style={{ overflow: 'hidden', flexShrink: 0 }}>
                    <div className="ts-card-head px-[14px] py-[10px]"
                      onClick={() => toggleSidebar('overview')}
                      style={{ fontSize: 9, fontWeight: 800, letterSpacing: '.09em', textTransform: 'uppercase', color: 'var(--text-color-calendar-week)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between', userSelect: 'none' }}>
                      <span>Week {weekIso} Overview</span>
                      <span style={{ fontSize: 10, opacity: .5, transition: 'transform .25s', transform: sidebarCollapsed.has('overview') ? 'rotate(-90deg)' : 'rotate(0deg)' }}>▾</span>
                    </div>
                    <div style={{ overflow: 'hidden', maxHeight: sidebarCollapsed.has('overview') ? 0 : 600, transition: 'max-height .3s cubic-bezier(.4,0,.2,1)' }}>
                    {week.slice(0, 5).map((day, i) => {
                      const totalM    = dayTotalsMap[day.format('YYYY-MM-DD')] ?? 0;
                      const label     = fmtMin(totalM);
                      const pct       = Math.min(100, fixPerWeek > 0 ? (totalM / (fixPerWeek / 5)) * 100 : 0);
                      const isToday   = day.isSame(dayjs(), 'day');
                      const dayRows_  = groupedRows[day.format('YYYY-MM-DD')] ?? [];
                      return (
                        <div key={i} style={{
                          display: 'flex', alignItems: 'center', gap: 10,
                          padding: '8px 14px', borderBottom: i < 4 ? '1px solid var(--border2-new)' : undefined,
                          background: isToday ? 'rgba(37,99,235,.06)' : undefined,
                          cursor: 'pointer', transition: 'background .12s',
                        }}
                          onMouseEnter={e => { if (!isToday) (e.currentTarget as HTMLElement).style.background = 'var(--hover-new)'; }}
                          onMouseLeave={e => { if (!isToday) (e.currentTarget as HTMLElement).style.background = isToday ? 'rgba(37,99,235,.06)' : 'transparent'; }}
                        >
                          <div style={{
                            width: 24, height: 24, borderRadius: 7, flexShrink: 0,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 11, fontWeight: 900,
                            background: isToday ? 'linear-gradient(135deg,#2563eb,#7c3aed)' : 'var(--btn-user-form)',
                            color: isToday ? 'white' : 'var(--text2, #5a6880)',
                            border: isToday ? 'none' : '1px solid var(--border-new)',
                          }}>{day.format('D')}</div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-color)' }}>{day.format('ddd')}</div>
                            <div style={{ fontSize: 9, color: 'var(--text-color-calendar-week)', marginTop: 1 }}>{dayRows_.length} {dayRows_.length === 1 ? 'entry' : 'entries'}</div>
                          </div>
                          <div style={{ width: 44, height: 3, borderRadius: 2, background: 'var(--border-new)', overflow: 'hidden' }}>
                            <div style={{ height: '100%', borderRadius: 2, width: `${pct}%`, background: '#059669', opacity: .6 }} />
                          </div>
                          <div style={{ fontSize: 11, fontWeight: 800, color: totalM > 0 ? '#059669' : 'var(--text-color-calendar-week)', fontVariantNumeric: 'tabular-nums', width: 32, textAlign: 'right' }}>{label}</div>
                        </div>
                      );
                    })}
                    <div className="ts-card-foot px-[14px] py-[9px]" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: '.08em', textTransform: 'uppercase', color: 'var(--text-color-calendar-week)' }}>Total</span>
                      <span style={{ fontSize: 18, fontWeight: 900, color: 'var(--text-color)', fontVariantNumeric: 'tabular-nums' }}>
                        {Math.floor(sum / 60)}:{(sum % 60).toFixed(0).padStart(2, '0')}<span style={{ fontSize: 11, fontWeight: 500, color: 'var(--text-color-calendar-week)' }}>h</span>
                      </span>
                    </div>
                    </div>{/* /slide overview */}
                  </div>

                  {/* Submit card */}
                  <div className="ts-card" style={{ overflow: 'hidden', flexShrink: 0 }}>
                    <div className="ts-card-head px-[14px] py-[10px]"
                      onClick={() => toggleSidebar('submit')}
                      style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', userSelect: 'none' }}>
                      <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: '.09em', textTransform: 'uppercase', color: 'var(--text-color-calendar-week)' }}>
                        {weekHasPending ? 'Submitted' : weekAllRejected ? 'Week returned' : 'Ready to submit?'}
                      </span>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <span style={{
                          padding: '2px 8px', borderRadius: 20, fontSize: 9, fontWeight: 700,
                          background: weekHasPending ? 'rgba(217,119,6,.12)' : weekAllRejected ? 'rgba(220,38,38,.12)' : 'rgba(100,116,139,.12)',
                          color: weekHasPending ? '#d97706' : weekAllRejected ? '#dc2626' : 'var(--text-color-calendar)',
                        }}>{weekHasPending ? 'Pending' : weekAllRejected ? 'Rejected' : 'Draft'}</span>
                        <span style={{ fontSize: 10, opacity: .5, transition: 'transform .25s', transform: sidebarCollapsed.has('submit') ? 'rotate(-90deg)' : 'rotate(0deg)' }}>▾</span>
                      </div>
                    </div>
                    <div style={{ overflow: 'hidden', maxHeight: sidebarCollapsed.has('submit') ? 0 : 400, transition: 'max-height .3s cubic-bezier(.4,0,.2,1)' }}>
                    <div style={{ padding: 14, display: 'flex', flexDirection: 'column', gap: 0 }}>
                      {[
                        { k: 'Logged',  v: `${Math.floor(sum / 60)}:${(sum % 60).toFixed(0).padStart(2, '0')}h`, c: '#059669' },
                        { k: 'Target',  v: `${Math.floor(fixPerWeek / 60)}:${(fixPerWeek % 60).toFixed(0).padStart(2, '0')}h` },
                        { k: 'TOIL',    v: `${convertToHoursAndMinutes(toils)}h`, c: '#d97706' },
                        { k: 'Entries', v: String(rows.length) },
                      ].map(({ k, v, c }) => (
                        <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0', borderBottom: '1px solid var(--border2-new)' }}>
                          <span style={{ fontSize: 11, color: 'var(--text-color-calendar-week)' }}>{k}</span>
                          <span style={{ fontSize: 11, fontWeight: 700, color: c || 'var(--text-color)', fontVariantNumeric: 'tabular-nums' }}>{v}</span>
                        </div>
                      ))}
                      <div style={{ height: 10 }} />
                      {weekAllRejected ? (
                        <>
                          <div style={{ textAlign: 'center', fontSize: 12, fontWeight: 700, color: '#dc2626', marginBottom: 8 }}>❌ Week returned by manager</div>
                          <button type="button"
                            style={{ width: '100%', padding: '8px 0', borderRadius: 10, border: 'none', background: 'linear-gradient(135deg,#dc2626,#b91c1c)', color: 'white', fontSize: 12, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7, boxShadow: '0 4px 14px rgba(220,38,38,.25)' }}
                            onClick={() => !loading && setShowAprove(true)}
                            disabled={loading}>
                            {loading ? <CircularProgress size={12} color="inherit" /> : '↺ ' + (t('ResubmitRejected') || 'Resubmit rejected')}
                          </button>
                          <div style={{ textAlign: 'center', fontSize: 10, color: 'var(--text-color-calendar-week)', marginTop: 8 }}>Edit entries and resubmit for approval</div>
                        </>
                      ) : !weekHasPending ? (
                        <>
                          <button type="button"
                            style={{ width: '100%', padding: '8px 0', borderRadius: 10, border: 'none', background: 'linear-gradient(135deg,#2563eb,#7c3aed)', color: 'white', fontSize: 12, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7, boxShadow: '0 4px 14px rgba(37,99,235,.25)' }}
                            onClick={() => !loading && setShowAprove(true)}
                            disabled={loading || rows.length === 0}>
                            {loading ? <CircularProgress size={12} color="inherit" /> : t('SendTo')}
                          </button>
                          <div style={{ textAlign: 'center', fontSize: 10, color: 'var(--text-color-calendar-week)', marginTop: 8 }}>Manager is notified by email</div>
                        </>
                      ) : (
                        <>
                          <div style={{ textAlign: 'center', fontSize: 12, fontWeight: 700, color: '#d97706', marginBottom: 8 }}>⏳ Awaiting approval</div>
                          {weekHasRejected && (
                            <button type="button"
                              style={{ width: '100%', padding: '8px 0', borderRadius: 10, border: 'none', background: 'linear-gradient(135deg,#dc2626,#b91c1c)', color: 'white', fontSize: 12, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7, marginBottom: 6 }}
                              onClick={() => !loading && setShowAprove(true)}
                              disabled={loading}>
                              {loading ? <CircularProgress size={12} color="inherit" /> : '↺ ' + (t('ResubmitRejected') || 'Resubmit rejected')}
                            </button>
                          )}
                          {canReturnWeek && (
                            <button type="button"
                              style={{ width: '100%', padding: '8px 0', borderRadius: 10, border: '1px solid rgba(217,119,6,.28)', background: 'rgba(217,119,6,.1)', color: '#d97706', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}
                              onClick={() => !loadingWeek && setReturnWeek(true)}
                              disabled={loadingWeek}>
                              {loadingWeek ? <CircularProgress size={12} color="inherit" /> : '↩ ' + t('ReturnWeek')}
                            </button>
                          )}
                        </>
                      )}
                    </div>
                    </div>{/* /slide submit */}
                  </div>

                </div>
              </div>
            ) : (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
                <CircularProgress />
              </Box>
            )}
          </TabPanel>

          {/* ═══ APPROVALS tab ═══ */}
          <TabPanel value="approvals" sx={{ padding: 'var(--space-l1) 0 0' }}>
            <Approvals access={access} refreshUserHeder={refreshUserHeder} staticDateCompany={staticDateCompany} />
          </TabPanel>

          <TabPanel value="reports_new" sx={{ padding: 'var(--space-l1) 0 0' }}>
            <ReportsNew access={access} taskOrTasks={taskOrTasks} staticDateCompany={staticDateCompany} />
          </TabPanel>

          {/* ═══ TEMPLATES tab (unchanged) ═══ */}
          {/* ═══ TOIL tab ═══ */}
          <TabPanel value="toil" sx={{ padding: 'var(--space-l1) 0 0' }}>
            {/* ── TOIL toolbar — static ── */}
            <PageToolbar mb='var(--space-l1)'>

              {/* Search + встроенный фильтр Contract — самый левый */}
              <SearchFilter grow columns={toilFilterColumns} search={toilSearch} onSearch={setToilSearch}
                filters={toilFilters} onFilters={setToilFilters} placeholder={t('fillter') || 'Search...'} />

              <div style={{ width: 1, height: 18, background: 'var(--border-input)', margin: '0 2px', flexShrink: 0 }} />

              {/* Period nav */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <button type="button"
                  className="bg-[var(--btn-user-form)] border border-[var(--border-input)] text-[var(--text-color)] rounded-[5px] cursor-pointer hover:bg-[var(--btn-user-hover)]"
                  style={{ width: 32, height: 32, fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  onClick={() => setToilCalOffset(o => o + 1)}>‹</button>
                <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-color)', minWidth: 130, textAlign: 'center' }}>
                  {toilPeriodLabel || '—'}
                </span>
                <button type="button"
                  className="bg-[var(--btn-user-form)] border border-[var(--border-input)] text-[var(--text-color)] rounded-[5px] cursor-pointer hover:bg-[var(--btn-user-hover)]"
                  style={{ width: 32, height: 32, fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: toilCalOffset === 0 ? .35 : 1 }}
                  disabled={toilCalOffset === 0}
                  onClick={() => setToilCalOffset(o => Math.max(0, o - 1))}>›</button>
              </div>

              <div style={{ flex: 1 }} />
            </PageToolbar>

            {/* ── TOIL content — scrollable ── */}
            <div className="section-scroll">
              {auth ? (
                <ToilCalendar
                  auth={auth}
                  access={access}
                  offset={toilCalOffset}
                  onOffsetChange={setToilCalOffset}
                  onPeriodLabel={setToilPeriodLabel}
                  searchFilter={toilSearch}
                  contractFilter={toilContractFilter}
                />
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
                  <CircularProgress />
                </Box>
              )}
            </div>
          </TabPanel>

          {/* Templates tab removed */}
        </TabContext>
      </Box>

      {/* ── Modals (all original) ── */}
      {showAprove && (
        <ApproveModal showAprove={showAprove} setShowAprove={setShowAprove} sendToApprove={sendToApprove} setQuestion="AreYouSureReport" />
      )}
      {showReturnWeek && (
        <ApproveModal showAprove={showReturnWeek} setShowAprove={setReturnWeek} sendToApprove={sendReturnWeek} setQuestion="AreYouSureBackWeek" />
      )}
      <TemplatesPanel
        open={showTemplatesPanel}
        onClose={() => { setShowTemplatesPanel(false); setPendingTemplateEntries([]); }}
        allTemplate={allTemplate}
        allCategory={allCategory}
        refresh={refreshTempaleList}
        refreshSelectTemplate={refreshSelectTemplate}
        usersSuperId={usersSuperId}
        is24HourFormat={is24HourFormat}
        taskOrTasks={taskOrTasks}
        openCheckModal={openCheckModal}
        pendingEntries={pendingTemplateEntries}
        onApplyTemplate={handleApplyFromPanel}
      />

      {/* ── Timesheets Settings Panel ── */}
      <SidePanel open={settingsOpen} onClose={() => setSettingsOpen(false)} width={624}>
        <SettingsPanelBody><TimesheetsSettings /></SettingsPanelBody>
      </SidePanel>

    </div>
  );
};

export default Timesheets;
